
const PrivacyPolicyPage = () => {
    return (
        <div id="contentpage">
            <div className="container my-4">
                <div className="content-page-card">
                    <h1 className="content-page-title">
                        <i className="bi bi-shield-lock me-2"></i>
                        Kebijakan Privasi
                    </h1>
                    <p className="content-page-updated">Terakhir diperbarui: 14 Maret 2026</p>

                    <section className="content-section">
                        <h5>1. Informasi yang Kami Kumpulkan</h5>
                        <p>Kami mengumpulkan informasi yang Anda berikan secara langsung saat mendaftar dan menggunakan layanan kami, termasuk:</p>
                        <ul>
                            <li>Nama dan alamat email</li>
                            <li>Foto profil (jika login melalui Google)</li>
                            <li>Data transaksi (Game ID, item yang dibeli, metode pembayaran)</li>
                            <li>Informasi perangkat dan browser</li>
                        </ul>
                    </section>

                    <section className="content-section">
                        <h5>2. Penggunaan Informasi</h5>
                        <p>Informasi yang kami kumpulkan digunakan untuk:</p>
                        <ul>
                            <li>Memproses dan memenuhi pesanan top up</li>
                            <li>Mengirimkan konfirmasi dan notifikasi transaksi</li>
                            <li>Meningkatkan kualitas layanan kami</li>
                            <li>Mencegah penipuan dan aktivitas ilegal</li>
                            <li>Menghubungi Anda terkait layanan atau promosi</li>
                        </ul>
                    </section>

                    <section className="content-section">
                        <h5>3. Keamanan Data</h5>
                        <p>Kami menggunakan teknologi enkripsi dan keamanan terkini untuk melindungi data pribadi Anda. Sistem autentikasi kami menggunakan Firebase Authentication dari Google untuk menjamin keamanan akun Anda.</p>
                    </section>

                    <section className="content-section">
                        <h5>4. Berbagi Informasi</h5>
                        <p>Kami tidak menjual atau menyewakan data pribadi Anda kepada pihak ketiga. Informasi hanya akan dibagikan dalam kondisi berikut:</p>
                        <ul>
                            <li>Untuk memproses transaksi dengan penyedia game terkait</li>
                            <li>Jika diwajibkan oleh hukum atau peraturan yang berlaku</li>
                            <li>Untuk melindungi hak dan keamanan platform</li>
                        </ul>
                    </section>

                    <section className="content-section">
                        <h5>5. Cookie</h5>
                        <p>Kami menggunakan cookie dan teknologi serupa untuk menyimpan preferensi Anda dan meningkatkan pengalaman pengguna. Anda dapat mengatur pengaturan cookie melalui browser Anda.</p>
                    </section>

                    <section className="content-section">
                        <h5>6. Hak Pengguna</h5>
                        <p>Anda memiliki hak untuk:</p>
                        <ul>
                            <li>Mengakses dan memperbarui data pribadi Anda</li>
                            <li>Meminta penghapusan akun dan data terkait</li>
                            <li>Menolak penggunaan data untuk tujuan pemasaran</li>
                        </ul>
                    </section>

                    <section className="content-section">
                        <h5>7. Perubahan Kebijakan</h5>
                        <p>Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu. Perubahan material akan diberitahukan melalui email atau notifikasi di platform. Kami menyarankan Anda untuk meninjau kebijakan ini secara berkala.</p>
                    </section>

                    <section className="content-section">
                        <h5>8. Kontak</h5>
                        <p>Untuk pertanyaan tentang kebijakan privasi ini, hubungi kami melalui fitur Customer Service atau media sosial resmi FamilyTopUp.</p>
                    </section>
                </div>
            </div>
        </div>
    )
}

export default PrivacyPolicyPage;